import React, { Component } from "react";
import ApplicationContext from "./ApplicationContext";
import axios from "axios";
import { baseUrl } from "../routes/routes";

axios.defaults.baseURL = baseUrl;
axios.interceptors.request.use(
  function (request) {
    if (localStorage.getItem("token")) {
      request.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    }
    return request;
  },

  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    if (response.data && !response.data.authentication) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      window.location.href = "/login";
    }

    return response;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export default class ApplicationProvider extends Component {
  // Life-Cycle Methods
  componentDidMount() {
  }

  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")) || null,
      permissions: JSON.parse(localStorage.getItem("permissions")) || [],
    };

  }

  setUserAndPermissions = (userData, userPermissions) => {
    this.setState({ user: userData, permissions: userPermissions });
  };

  render() {
    const { user, permissions } = this.state;
    return (
      <ApplicationContext.Provider
        value={{
          user,
          permissions,
          setUserAndPermissions: this.setUserAndPermissions,
          auth: !!user,
        }}
      >
      {this.props.children}
      </ApplicationContext.Provider>
    );
  }
}